
import React, { useState, useEffect, useRef, FaIcons, useMemo } from "react";
import DraggableTable from "../../Common Components/Draggable_Rows_Table";
import { DragDropContext } from "react-beautiful-dnd";
import EventServiceController from "../../../Controllers/EventService";
import "react-toastify/dist/ReactToastify.css";
import CustomToaster, { notify } from "../../Common Components/Custom_Toaster";
import { Clear, Search } from "@mui/icons-material";
import WorkflowTemplateServiceController from "../../../Controllers/WorkflowTemplateservice";
import "./EventCreation.css";
import EventConfirmPopup from "../../Common Components/Event_Confirm_Popup";
import IconPickerModal from "../../Tab Content/Events/Event Components/IconPicker/IconPickerModal";
import IconRenderer from "../../Tab Content/Events/Event Components/IconPicker/IconRenderer";
import Config from "../../../../src/API Service/ConfigUrl";
import { Tooltip } from '@mui/material';
import { IconButton, } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ConfirmPopup from '../../Common Components/Confirm_Popup';


var config = new Config();
var baseUrl = config.apiUrl;


const EventCreation = ({ handleEventEditClick, eventCalloutName, primaryEventSearchText, selectedEventSearchText, eventSearchClear, handleSearchChange, toolTipData }) => {
  const sourceTableHeading = ["", "Level", "Event name", ""];
  const [activeTab, setActiveTab] = useState("general");
  const [activeGlobalTab, setActiveGlobalTab] = useState("active");

  const [listTableRows, setListTableRows] = useState([]);
  const [listTableInactiveRows, setListTableInactiveRows] = useState([]);
  const [primaryInactiveEventSearchText, setPrimaryInactiveEventSearchText] = useState('');


  const [shouldReload, setShouldReload] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [legend, setLegend] = useState([]);

  const [selectedEvent, setSelectedEvent] = useState(null);
  const [selectedEventType, setSelectedEventType] = useState(null);
  const [eventTypeList, setEventTypeList] = useState([]); // array
  const [apiSelectedSwagger, setApiSelectedSwagger] = useState([]);
  const [status, setStatus] = useState(false);
  const [shouldIframeReload, setShouldIframeReload] = useState(false);
  const inputRef = useRef(null);
  const [selectedEventStatus, setSelectedEventStatus] = useState("active");

  // form states
  const [eventId, setEventId] = useState("");
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [permissionset, setPermission] = useState("");

  const eventCont = new EventServiceController();
  var Spinner = require('react-spinkit');

  const workflowTempCont = new WorkflowTemplateServiceController();
  const [workflowLevelComp, setWorkflowLevelComp] = useState([]);
  const [recruitmentEventTypes, setRecruitmentEventTypes] = useState([]);
  const [selectedLevel, setSelectedLevel] = useState('');
  const [selectedRecruitmentEventTypes, setSelectedRecruitmentEventTypes] = useState("");
  const [selectedSwagger, setSelectedSwagger] = useState({id:"",url:""});
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [apiError, setApiError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const [existingSelectedPermission, setExistingSSelectedPermission] = useState([]);
  const [selectedPermission, setSelectedPermission] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedIcon, setSelectedIcon] = useState(null); // {name, icon}

  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isRulesDelete, setIsRulesDelete] = useState(false);

  const [ruleId, setRuleId] = useState("");
  const [ruleEngine, setRuleEngine] = useState("");

  const [ruleConstraint, setRuleConstraint] = useState("");
  const [ruleConstraintValue, setRuleConstraintValue] = useState("");
  const [rulesList, setRulesList] = useState([]);
  const [ruleConstraintList, setRuleConstraintList] = useState([]); // list
  const [ruleConstraintValueList, setRuleConstraintValueList] = useState([]); // list
  const [ruleCalloutName, setRuleCalloutName] = useState("");
  const [disabledCalloutName, setDisabledCalloutName] = useState(true);

  const permissions = [
    { id: 1, name: "View" },
    { id: 2, name: "Add" },
    { id: 3, name: "Edit" },
    { id: 4, name: "Delete" },
    { id: 5, name: "Execute" }
  ];
  useEffect(() => {
    getSkillLeveldropdown();
    getEventTypedropdown();
    getGetApiEndPointDropdown();
    getRecruitmentEventTypes();
  }, []);

  // const [showPopup, setShowPopup] = useState(false);
  // const [postContent, setPostContent] = useState("");
  // // OPEN CONTENT POPUP
  // const openContentPopup = () => {
  //   setShowPopup(true);
  // };
  // const loginWithLinkedIn = () => {
  //   const popup =
  //     window.open("https://localhost:44359/api/WFEvent/LinkedInLogin", "_blank", "width=600,height=700");
  //   window.addEventListener("message", (event) => {
  //     console.log("LinkedIn Token:", event.data);
  //     // Store token
  //     localStorage.setItem("linkedin_token", event.data.access_token);
  //     console.log("LinkedIn Token access_token:", event.data.access_token);
  //     postToLinkedIn(postContent);
  //   },
  //     false);
  // };
  // const postToLinkedIn = async (content) => {

  //   const accessToken = localStorage.getItem("linkedin_token");

  //   const response =
  //     await fetch(`https://localhost:44359/api/WFEvent/ugcPosts?accessToken=${accessToken}`,
  //       {
  //         method: "POST",
  //         headers:
  //         {
  //           "Content-Type": "application/json"
  //         },

  //         body: JSON.stringify({ text: content })
  //       });

  //   const data = await response.json();
  //   console.log(data);
  //   setPostContent("");
  // };
  const getSkillLeveldropdown = async () => {
    const body = await workflowTempCont.getSidebarComponents();
    setWorkflowLevelComp(
      Array.isArray(body) && body.length > 0 ?
        body.map((levelComp, index) => ({
          id: levelComp.id,
          levelCode: levelComp.levelCode,
          levelName: levelComp.levelName,
          mappedsubflowId: levelComp.mappedSubflowId,
        })
        )
        :
        []
    )
  };
  const getRecruitmentEventTypes = async () => {
    
    const body = await workflowTempCont.getEventTypes();
    setRecruitmentEventTypes(
      Array.isArray(body.data) && body.data.length > 0 ?
        body.data.map((eventTypes, index) => ({
          id: eventTypes.recruitmentEventId,
          eventTypeName: eventTypes.eventName,
        })
        )
        :
        []
    )
  }

  const getEventTypedropdown = async () => {
    const body = await workflowTempCont.getEventTypedropdown();
    setEventTypeList(
      Array.isArray(body) && body.length > 0 ?
        body.map((levelComp, index) => ({
          id: levelComp.id,
          typeColor: levelComp.typeColor,
          typeName: levelComp.typeName,
        })
        )
        :
        []
    )
  }
  const getGetApiEndPointDropdown = async () => {
    try {
      // const body = await workflowTempCont.getGetApiEndPointdropdown();
      // const urlBuild = baseUrl.replace(/api\/?$/, "").replace(/\/$/, "");
      // const result = Array.isArray(body)
      //   ? body.map(levelComp => ({
      //     id: levelComp.eventId,
      //     urlName: levelComp.description,
      //     url: `${urlBuild}/swagger/index.html#/${levelComp.controller}/${levelComp.actionMethod}`,
      //   }))
      //   : [];
      // setApiSelectedSwagger(result);

      const body = await workflowTempCont.getEventTypes();
      const urlBuild = baseUrl.replace(/api\/?$/, "").replace(/\/$/, "");
      const result = Array.isArray(body.data)
        ? body.data.map(levelComp => ({
          id: levelComp.recruitmentEventId,
          urlName: levelComp.eventName,
          url: `${urlBuild}/swagger/index.html#/${levelComp.controllerName}/${levelComp.apiActionName}`,
        }))
        : [];
      setApiSelectedSwagger(result);
    } catch (error) {
      console.error("Failed to load API endpoint dropdown", error);
      setApiSelectedSwagger([]);
    }
  };


  const getPrimaryEventsData = async () => {
    const body = await eventCont.getPrimaryEventsList();
    if (Array.isArray(body) && body.length > 0) {
      // Sort by numeric part of eventLevel (e.g., 'L10' -> 10)
      const sortedBody = body.sort((a, b) => {
        const aLevel = parseInt(a.eventLevel.replace(/\D/g, ""), 10); // Extract number
        const bLevel = parseInt(b.eventLevel.replace(/\D/g, ""), 10);
        return aLevel - bLevel;
      });
      setListTableRows(
        body.map((item, index) => ({
          sNo: index + 1,
          eventLevel: item.eventLevel,
          eventName: item.eventCode,
          eventId: item.id,
          iconName: item?.iconName ? JSON.stringify(item.iconName) : "",
          isActive: item.isActive,
          eventColor: item.typeColor,
          eventType: item.typeName,
          eventCode: item.eventName,
          permission: item.permission,
          recruitmentEventDefinitionId:item.recruitmentEventDefinitionId,

        }))
      );

      // Extract unique types for legend as before
      const uniqueTypes = Array.from(new Set(sortedBody.map((item) => item.typeName)))
        .map((typeName) => {
          const item = sortedBody.find((item) => item.typeName === typeName);
          return {
            name: typeName,
            color: item.typeColor,
            level: item.eventLevel,
          };
        });

      setLegend(() => [...uniqueTypes]);
    } else {
      setListTableRows([]);
    }
  };

  const getInactivePrimaryEvents = async () => {
    const body = await eventCont.getInactivePrimaryEventsList('false');
    if (Array.isArray(body) && body.length > 0) {
      // Sort by numeric part of eventLevel (e.g., 'L10' -> 10)
      const sortedBody = body.sort((a, b) => {
        const aLevel = parseInt(a.eventLevel.replace(/\D/g, ""), 10); // Extract number
        const bLevel = parseInt(b.eventLevel.replace(/\D/g, ""), 10);
        return aLevel - bLevel;
      });
      setListTableInactiveRows(
        body.map((item, index) => ({
          sNo: index + 1,
          eventLevel: item.eventLevel,
          eventName: item.eventCode,
          eventId: item.id,
          iconName: item?.iconName ? JSON.stringify(item.iconName) : "",
          isActive: item.isActive,
          eventColor: item.typeColor,
          eventType: item.typeName,
          eventCode: item.eventName,
          permission: item.permission,

        }))
      );

      // Extract unique types for legend as before
      const uniqueTypes = Array.from(new Set(sortedBody.map((item) => item.typeName)))
        .map((typeName) => {
          const item = sortedBody.find((item) => item.typeName === typeName);
          return {
            name: typeName,
            color: item.typeColor,
            level: item.eventLevel,
          };
        });

      setLegend(() => [...uniqueTypes]);
    } else {
      setListTableRows([]);
    }
  };

  const fetchData = async () => {
    setIsProcessing(true);
    await getPrimaryEventsData();
    setIsProcessing(false);
    setShouldReload(false);
    //await getInactivePrimaryEvents();
  }

  useEffect(() => {
    fetchData();
  }, [shouldReload]);

  const isNullOrEmpty = (val) => val === null || val === undefined || val === '';

  const handleSaveConfirm = async () => {
    if (isRulesDelete) {
      setIsRulesDelete(false);
      setIsPopupOpen(false);
      handleDelete(ruleId);
    }
    else {
      setIsPopupOpen(false);
      const permissionString = selectedPermission.join(",");
      setIsProcessing(true);
      setStatus(true);
      const selectedIconselectedIcon = JSON.stringify(selectedIcon);
      console.log(selectedIconselectedIcon);
      const eventRows = {
        id: eventId || 0,
        eventCode: name,
        displayName: description,
        wFLevel_Id: selectedLevel,
        eventTypeId: selectedEventType || 1,
        permission: permissionString,
        recruitmentEventDefinitionId : Number(selectedSwagger.id),
        iconName: selectedIcon,
        isActive: selectedEventStatus === "active",
      };
      
      const body = await eventCont.addUpdateEvents(eventRows);      
      if (!body?.includes("mapped")) {
        if (selectedEventStatus === "inactive") {
          notify(`"${name}" has been  ${selectedEventStatus} Successfully`, true);
        }
        else if (body?.includes("exists")) {
          notify(`${body}`, false);
        }
        else {
          notify(`"${name}" has been ${body}`, true);
        }
        fetchData();
        clearRowsAPI();
      } else {
        notify(`${body}`, false);
      }
      setIsProcessing(false);
    }
  }
  const updateRowsAPI = async () => {
    if (isNullOrEmpty(name) || isNullOrEmpty(description) || isNullOrEmpty(selectedLevel)) {
      notify(
        `One or more required fields are empty`,
        false
      );
      return;
    }
    if (!selectedPermission || selectedPermission.length === 0) {
      notify("Please select the permission for the respective event.", false);
      return;
    }
    if (selectedSwagger.id === "") {
      notify("Please select the api end point from the advance tab for the respective event.", false);
      return;
    }
    if (existingSelectedPermission.length == 0 || existingSelectedPermission === selectedPermission) {
      handleSaveConfirm();
    }
    else {
      if (existingSelectedPermission > selectedPermission) {
        ConfirmUpdateForDownUpgrade('Downgrade');
      }
      else {
        ConfirmUpdateForDownUpgrade('Upgrade');
      }
    }
  };
  const saveRulesRows = async () => {
    try {
      const payload = rulesList.map(rule => ({
        id: rule.id || 0,
        eventId: eventId,
        ruleName: rule.name,
        isActive: true
      }));
      const response = await eventCont.addUpdateEventRule(payload);
      notify("Rules saved successfully", true);
    } catch (error) {
      console.error(error);
      notify("Error saving rules", false);
    }
  };
  const clearRowsAPI = async () => {
    setEventId(0);
    setName('');
    setDescription('');
    setSelectedLevel('');
    setSelectedRecruitmentEventTypes("");
    setSelectedRowId(0);
    setSelectedEventType(null);
    setStatus(false);
    setSelectedIcon(null);
    setSelectedPermission([]);
    setSelectedEventStatus('active');
    setRuleId("");
    setRuleConstraint("");
    setRuleEngine(""); // clear input
    setRuleCalloutName("");
    setSelectedSwagger({id:"",url:""});
    setShouldIframeReload(false);
    setExistingSSelectedPermission([]);
  };


  const [confirmPopupData, setConfirmPopupData] = useState({
    title: 'Confirm Down/Upgrade Changes',
    popupType: 'Yes',
    name: ''
  });
  const ConfirmUpdateForDownUpgrade = async (states) => {
    setConfirmPopupData(prev => ({
      ...prev,
      title: `Permission ${states}`,
      popupType: "Yes",
      name: `Are you sure you want to ${states} the permission? Or would you like to discard the changes?`
    }));

    setIsPopupOpen(true);
  };
  const filteredPrimaryEvents = listTableRows.filter(event => event.eventName.toLowerCase().includes(primaryEventSearchText.toLowerCase()));
  const filteredPrimaryInactiveEvents = listTableInactiveRows.filter(event => event.eventName.toLowerCase().includes(primaryInactiveEventSearchText.toLowerCase()));

  const handleInactiveSearchChange = (eventType, event) => {
    switch (eventType) {
      case 'inactiveprimaryEvent':
        setPrimaryInactiveEventSearchText(event.target.value);
        break;
      default:
        console.log('no event search to clear');
    }
  }
  const handleInactiveEventSearchClear = (eventType) => {
    switch (eventType) {
      case 'inactiveprimaryEvent':
        setPrimaryInactiveEventSearchText('');
        break;
      default:
        console.log('no event search to clear');
    }
  }
  const handleEventRowClick = (eventRow) => {
    setRuleId("");
    setRuleConstraint("");
    setRuleEngine(""); // clear input
    setRuleCalloutName("");

    setSelectedRowId(eventRow.eventId); // or item.eventId
    setSelectedEvent(eventRow);
    setEventId(eventRow.eventId || "");
    setName(eventRow.eventName || "");
    setDescription(eventRow.eventCode || "");
    setSelectedIcon(eventRow.iconName ? JSON.parse(eventRow.iconName) : null);
    handleFetch(eventRow.eventId);
    const statusisActive = eventRow.isActive === true ? "active" : "inactive";
    setSelectedEventStatus(statusisActive);
    const level = workflowLevelComp.find(
      item => item.levelName === eventRow.eventLevel
    );

    setSelectedLevel(level ? level.id : "");

    const eventType = recruitmentEventTypes.find(
      item => item.id === eventRow.recruitmentEventDefinitionId
    );

    setSelectedRecruitmentEventTypes(eventType ? eventType.id : "");

    const permissionArray = eventRow?.permission
      ? eventRow.permission.toString().split(",").map(Number)
      : [];

    setSelectedPermission(permissionArray);
    setExistingSSelectedPermission(permissionArray);

    const selectedItem = apiSelectedSwagger.find(
      item => item.id === eventRow.recruitmentEventDefinitionId
    );

    if (!selectedItem?.url) {
      setShouldIframeReload(false);
      setSelectedSwagger({
        id: "",
        url: ""
      });
      setApiError('API endpoint not assigned');
      return;
    }

    const isSwaggerUrl = selectedItem.url.includes('post_api_') || selectedItem.url.includes('get_api_') || selectedItem.url.includes('put_api_') || selectedItem.url.includes('delete_api_');

    if (isSwaggerUrl) {
      setSelectedSwagger({
        id: selectedItem.id,
        url: selectedItem.url
      });
      setShouldIframeReload(true);
      setApiError('');
    } else {
      setShouldIframeReload(false);
      setSelectedSwagger({
        id: "",
        url: ""
      });
      setApiError('API endpoint not assigned');
    }

  };

  const dropdownRef = useRef(null);

  // Toggle checkbox selection
  const handleCheckboxChange = (id) => {
    if (selectedPermission.includes(id)) {
      setSelectedPermission(selectedPermission.filter((item) => item !== id));
    } else {
      setSelectedPermission([...selectedPermission, id]);
    }
  };

  // Close dropdown on outside click
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const openPopupEvent = () => {
    setIsPopupOpen(!isPopupOpen);
  };
  const handleCancel = async () => {
    setIsPopupOpen(false);
    setSelectedPermission(existingSelectedPermission);
  };

  const addRule = async () => {

    if(!eventId || eventId === 0){
      notify("Please add event before adding constraints",false);
      return;
    }
    // Provides an empty object as a fallback to prevent downstream breaks
    const selectedConstraint = ruleConstraintList.find((item) => item.id === ruleConstraint) ?? {};

    // Provides a specific default label if the value isn't found
    const selectedValue = selectedConstraint?.workFlowEventConstraintValues?.find((item) => item.id === Number(ruleConstraintValue)) ?? {};


    if (!selectedConstraint.constraint?.trim()) {
      notify("Select Constraint is required", false);
      return;
    }


    if (!ruleCalloutName.trim()) {
      notify("The CalloutName is required", false);
      return;
    }
    try {
      const payload = ({
        id: ruleId || 0,
        eventId: eventId,
        workFlowEventConstraintId: selectedConstraint?.id,
        callOutName: ruleCalloutName,
        constraintValueId: selectedValue?.id ?? null,
      });
      const response = await eventCont.addUpdateEventRule(payload);
      if (response.success || response.Success) {
        notify("Rules saved successfully", true);
      }
      else {
        const message = response.response?.replace("Message:", "").trim();
        notify(message, false);
      }
      handleFetch(eventId);
    } catch (error) {
      console.error(error);
      notify("Error saving rules", false);
    }
    setRuleId("");
    setRuleConstraint("");
    setRuleEngine(""); // clear input
    setRuleCalloutName("");
  };

  const handleDelete = async (id) => {
    const response = await eventCont.deleteRulesEventRule(id);
    notify(response?.Response, response?.Success); // ✅ correct
    handleFetch(eventId);
    setRuleId("");
    setRuleConstraint("");
    setRuleEngine(""); // clear input
    setRuleCalloutName("");
  };
  const handleEdit = async (id) => {
    const updatedList = rulesList.filter(rule => rule.id === id);
    setRuleId(updatedList[0].id);
    setRuleConstraint(updatedList[0].constraint);
    setRuleEngine(updatedList[0].name);
  };

  const handleFetch = async (eventId) => {
    const response = await eventCont.getRulesEventRule(eventId);
    setRulesList(
      response?.map((rule) => ({
        id: rule.id,
        constraint: rule.workFlowEventConstraint,
        calloutName: rule.callOutName,
        name: rule.constraintValue,
      })) || []
    );
  };


  const ConfirmtoDeleteRules = (states, id) => {
    setConfirmPopupData(prev => ({
      ...prev,
      title: `Confirmation ${states}`,
      popupType: "Yes",
      name: `Are you sure you want to ${states}?`
    }));
    setIsRulesDelete(true);
    setRuleId(id);
    setIsPopupOpen(true);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await eventCont.getConstaintsRulesEventValue();
        // ensure fallback for safety
        const normalizedData = response.map((item) => ({
          ...item, workFlowEventConstraintValues: item.workFlowEventConstraintValues || [],
        }));

        setRuleConstraintList(normalizedData);
      } catch (error) {
        console.error("Error fetching constraints:", error);
      }
    };

    fetchData();
  }, []);
  const filteredValues = useMemo(() => {
    const selected = ruleConstraintList.find((item) => item.id === Number(ruleConstraint));
    return selected?.workFlowEventConstraintValues || [];
  }, [ruleConstraint, ruleConstraintList]);

  // const { filteredValues, calloutName } = useMemo(() => {
  //   const selected = ruleConstraintList.find(
  //     (item) => item.id === Number(ruleConstraint)
  //   );

  //   return {
  //     filteredValues: selected?.workFlowEventConstraintValues || [],
  //     calloutName: selected?.calloutName || ""
  //   };
  // }, [ruleConstraint, ruleConstraintList]);
  const getCalloutNameFromConstraintdropdown = async (e) => {
    try {
      const constraintId = e.target.value;
      const response = await eventCont.getCalloutNameFromConstraint(eventId, constraintId);
      if (response != "") {
        setRuleCalloutName(response);
      }
      else {
        setRuleCalloutName("");
        setDisabledCalloutName(false);
        // wait for state update, then focus
        setTimeout(() => {
          inputRef.current?.focus();
        }, 0);
      }
    } catch (error) {
      console.error(error);
    }
  }
  return (
    <>
      <style>
        {`
           input::placeholder {
             color: #cfd4e9;
           }
         `}
      </style>

      {
        isProcessing ?
          <>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '80%' }}>
              <Spinner name="ball-spin-fade-loader" color="#02acf6" />
            </div>
          </> :
          <>
            <DragDropContext>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "99%",
                  padding: "0px 20px",
                  marginTop: "15px",
                }}
              >
                <div
                  style={{
                    width: "48%",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <div className="tabs">
                    <span
                      className={activeGlobalTab === "active" ? "tab active" : "tab"}
                      onClick={() => { getPrimaryEventsData(); setActiveGlobalTab("active"); clearRowsAPI(); }}
                    >
                      Active
                    </span>
                    <span
                      className={activeGlobalTab === "inactive" ? "tab active" : "tab"}
                      onClick={() => { getInactivePrimaryEvents(); setActiveGlobalTab("inactive"); clearRowsAPI(); }}
                    >
                      Inactive
                    </span>

                  </div>
                  {activeGlobalTab === "active" && (
                    <div className="form-group-event">
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginLeft: "30px",
                          marginTop: "15px",
                          width: "100%",
                        }}
                      >
                        <p style={{ fontSize: "20px", fontWeight: 'bold', fontFamily: 'Montserrat,sans-serif', }}>
                          Active Global Events ({filteredPrimaryEvents.length})
                        </p>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', border: '1px solid #cfd4e9', borderRadius: '4px', }}>
                          <input
                            type="text"
                            placeholder="Search..."
                            value={primaryEventSearchText}
                            onChange={(event) => handleSearchChange('primaryEvent', event)}
                            style={{ height: "38px", width: "80%", border: 'none', borderRadius: '4px', outline: 'none' }}
                          />
                          {(primaryEventSearchText === '' || primaryEventSearchText === undefined) ? <Search style={{ color: '#757ea5' }} /> : <Clear style={{ color: '#757ea5' }} onClick={() => eventSearchClear('primaryEvent')} sx={{ cursor: 'pointer' }} />}
                        </div>

                      </div>
                      <DraggableTable
                        row={filteredPrimaryEvents}
                        heading={sourceTableHeading}
                        template={false}
                        workflow={false}
                        event={true}
                        task={false}
                        droppableId="eventCreateTable"
                        onEventClick={handleEventRowClick}
                        selectedRowId={selectedRowId}
                        globalEvent={true}
                      />
                    </div>
                  )}
                  {activeGlobalTab === "inactive" && (
                    <div className="form-group-event">
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginLeft: "30px",
                          marginTop: "15px",
                          width: "100%",
                        }}
                      >
                        <p style={{ fontSize: "20px", fontWeight: 'bold', fontFamily: 'Montserrat,sans-serif', }}>
                          Inactive Global Events ({filteredPrimaryInactiveEvents.length})
                        </p>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', border: '1px solid #cfd4e9', borderRadius: '4px', }}>
                          <input
                            type="text"
                            placeholder="Search..."
                            value={primaryInactiveEventSearchText}
                            onChange={(event) => handleInactiveSearchChange('inactiveprimaryEvent', event)}
                            style={{ height: "38px", width: "80%", border: 'none', borderRadius: '4px', outline: 'none' }}
                          />
                          {(primaryInactiveEventSearchText === '' || primaryInactiveEventSearchText === undefined) ? <Search style={{ color: '#757ea5' }} /> : <Clear style={{ color: '#757ea5' }} onClick={() => handleInactiveEventSearchClear('inactiveprimaryEvent')} sx={{ cursor: 'pointer' }} />}
                        </div>

                      </div>
                      <DraggableTable
                        row={filteredPrimaryInactiveEvents}
                        heading={sourceTableHeading}
                        template={false}
                        workflow={false}
                        event={true}
                        task={false}
                        droppableId="eventCreateTable"
                        onEventClick={handleEventRowClick}
                        selectedRowId={selectedRowId}
                        globalEvent={true}
                      />
                    </div>
                  )}
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "49%",
                    minHeight: "300px",
                    maxHeight: "875px",
                    overflowY: "hidden",      // ✅ vertical scroll only
                    overflowX: "hidden",    // ✅ prevent horizontal scroll
                    boxSizing: "border-box",
                    padding: "0px 20px",
                    marginTop: "75px",
                  }}
                >
                  {/* RIGHT PANEL */}
                  <div className="event-properties">
                    <h3>Properties</h3>
                    <div className="tabs">
                      <span
                        className={activeTab === "general" ? "tab active" : "tab"}
                        onClick={() => setActiveTab("general")}
                      >
                        General
                      </span>
                      <span
                        className={activeTab === "advance" ? "tab active" : "tab"}
                        onClick={() => setActiveTab("advance")}
                      >
                        Advance
                      </span>
                      <span
                        className={activeTab === "permission" ? "tab active" : "tab"}
                        onClick={() => setActiveTab("permission")}
                      >
                        Permission
                      </span>
                      <span
                        className={activeTab === "rules" ? "tab active" : "tab"}
                        onClick={() => setActiveTab("rules")}
                      >
                        Constraint Parameter
                      </span>
                    </div>

                    {activeTab === "general" && (
                      <div className="form">
                        <div className="form-group">
                          <div className="two-selects">
                            <div className="select-box">
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "flex-start",
                                  gap: "20px",
                                }}
                              >
                                {/* ICON SECTION */}
                                <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                  {/* Label BELOW icon */}
                                  <label style={{ marginTop: "6px" }}>
                                    Event Icon
                                  </label>
                                  <Tooltip title={selectedIcon?.name?.slice(2)}>
                                    <button
                                      type="button"
                                      title={selectedIcon?.name}
                                      onClick={() => setIsOpen(true)}
                                      style={{
                                        padding: "10px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        border: "1px solid #ccc",
                                        borderRadius: "6px",
                                        background: "#fff",
                                        cursor: "pointer",
                                        width: 50,
                                        height: 50,
                                      }}
                                    >
                                      {selectedIcon ? (
                                        <IconRenderer iconObj={selectedIcon} size={18} />
                                      ) : (
                                        "Click"
                                      )}
                                    </button>
                                  </Tooltip>
                                </div>
                                {/* INPUT SECTION */}
                                <div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
                                  {/* Label BELOW input */}
                                  <label style={{ marginTop: "6px" }}>
                                    Event Name <span style={{color:"red"}}>*</span>
                                  </label>
                                  <input
                                    id="eventName"
                                    type="text"
                                    value={name}
                                    placeholder="Event Name"
                                    onChange={(e) => setName(e.target.value)}
                                    style={{ padding: "6px", width: "100%" }}
                                  />
                                </div>
                              </div>

                              {/* Modal */}
                              <IconPickerModal
                                isOpen={isOpen}
                                onClose={() => setIsOpen(false)}
                                onSelect={(iconObj) => {
                                  setSelectedIcon(iconObj);
                                  setIsOpen(false);
                                }}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="form-group">
                          <label>Description <span style={{color:"red"}}>*</span></label>
                          <input
                            type="text"
                            value={description}
                            placeholder="Description"
                            onChange={(e) => setDescription(e.target.value)}
                          />
                        </div>
                        <div className="form-group">
                          <div className="two-selects">
                            <div className="select-box">
                              <label>Level<span style={{color:"red"}}>*</span></label>
                              {/* 🔹 Row container */}
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "10px",
                                }}
                              >
                                {/* Dropdown */}
                                <select
                                  value={selectedLevel}
                                  onChange={(e) => setSelectedLevel(e.target.value)}
                                  style={{ padding: "6px", width: "250px", marginBottom: "0px" }}
                                >
                                  <option value="">Select</option>
                                  {workflowLevelComp.map((item) => (
                                    <option key={item.id} value={item.id}>
                                      {item.levelName}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>

                            <div className="select-box">
                              <label
                                style={{
                                  display: "block",
                                  marginBottom: "10px",
                                  fontWeight: "500",
                                  color: "#757EA5",
                                }}
                              >
                                Event Status
                              </label>

                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "25px",
                                }}
                              >
                                <label
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "6px",
                                    cursor: "pointer",
                                    fontSize: "16px",

                                  }}
                                >
                                  <input
                                    type="radio"
                                    name="eventStatus"
                                    value="active"
                                    checked={selectedEventStatus === "active"}
                                    onChange={(e) => setSelectedEventStatus(e.target.value)}
                                    style={{
                                      margin: 0,
                                      width: "16px",

                                    }}
                                  />
                                  Active
                                </label>

                                <label
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "6px",
                                    cursor: "pointer",
                                    fontSize: "16px",

                                  }}
                                >
                                  <input
                                    type="radio"
                                    name="eventStatus"
                                    value="inactive"
                                    checked={selectedEventStatus === "inactive"}
                                    onChange={(e) => setSelectedEventStatus(e.target.value)}
                                    style={{
                                      margin: 0,
                                      width: "16px",

                                    }}
                                  />
                                  Inactive
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div>
                        </div>
                        <div className="btn-wrapper">
                          {/* INPUT SECTION 

                        <button className="submit-btn" onClick={openContentPopup}>
                            Post LinkedIn
                          </button>   
                          {
                            showPopup && (

                              <div
                                style={{
                                  position: "fixed",
                                  top: 0,
                                  left: 0,
                                  width: "100%",
                                  height: "100%",
                                  background: "rgba(0,0,0,0.6)",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  zIndex: 9999,
                                  backdropFilter: "blur(4px)"
                                }}>

                                <div
                                  style={{
                                    background: "#ffffff",
                                    width: "500px",
                                    borderRadius: "16px",
                                    padding: "30px",
                                    boxShadow:
                                      "0 10px 30px rgba(0,0,0,0.2)",
                                    animation:
                                      "popupFade 0.3s ease",
                                    fontFamily:
                                      "Arial, sans-serif"
                                  }}>

                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      marginBottom: "20px"
                                    }}>

                                    <h2
                                      style={{
                                        margin: 0,
                                        fontSize: "24px",
                                        color: "#0A66C2"
                                      }}>
                                      Create LinkedIn Post
                                    </h2>

                                    <button
                                      onClick={() =>
                                        setShowPopup(false)
                                      }
                                      style={{
                                        border: "none",
                                        background: "transparent",
                                        fontSize: "22px",
                                        cursor: "pointer",
                                        color: "#666"
                                      }}>
                                      ×
                                    </button>

                                  </div>

                                  <textarea
                                    rows="6"
                                    placeholder="Post activity into LinkedIn?"
                                    style={{
                                      width: "100%",
                                      padding: "15px",
                                      borderRadius: "10px",
                                      border:
                                        "1px solid #d0d7de",
                                      resize: "none",
                                      fontSize: "16px",
                                      outline: "none",
                                      boxSizing: "border-box",
                                      marginBottom: "20px"
                                    }}
                                    value={postContent}
                                    onChange={(e) =>
                                      setPostContent(
                                        e.target.value)
                                    }
                                  />

                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "flex-end",
                                      gap: "10px"
                                    }}>

                                    <button
                                      onClick={() =>
                                        setShowPopup(false)
                                      }
                                      style={{
                                        padding:
                                          "10px 18px",
                                        borderRadius: "8px",
                                        border:
                                          "1px solid #ccc",
                                        background: "#fff",
                                        cursor: "pointer",
                                        fontSize: "14px"
                                      }}>
                                      Cancel
                                    </button>

                                    <button
                                      onClick={() => {

                                        setShowPopup(false);

                                        loginWithLinkedIn();

                                      }}
                                      style={{
                                        padding:
                                          "10px 20px",
                                        borderRadius: "8px",
                                        border: "none",
                                        background: "#0A66C2",
                                        color: "white",
                                        fontSize: "15px",
                                        fontWeight: "bold",
                                        cursor: "pointer",
                                        transition:
                                          "0.3s"
                                      }}>
                                      Continue To LinkedIn
                                    </button>

                                  </div>

                                </div>

                              </div>
                            )
                          } */}
                          <button className="submit-btn" onClick={clearRowsAPI}>
                            Clear Event
                          </button>
                          <button className="submit-btn" onClick={updateRowsAPI}>
                            {eventId > 0 ? 'Update Event' : 'Save Event'}
                          </button>
                        </div>
                      </div>
                    )}
                    {activeTab === "advance" && (
                      <div
                        className="form"
                        style={{
                          fontFamily: "Arial, sans-serif",
                          maxHeight: "380px", // adjust height as needed
                          overflowY: "auto",
                          padding: "10px",
                          border: "1px solid #ccc",
                          borderRadius: "4px",
                        }}
                      >
                        <select
                          value={selectedSwagger?.id ?? ""}
                          onChange={(e) => {setSelectedSwagger({
                            id:e.target.value,
                            url:apiSelectedSwagger.find((s)=>s?.id === Number(e.target.value)).url
                          });
                          setShouldIframeReload(true)
                        }}
                        >
                          <option value="" hidden>Select</option>
                          {apiSelectedSwagger.map((item) => (
                            <option key={item.id} value={item.id}>
                              {item.urlName}
                            </option>
                          ))}
                        </select>
                        {/* */}
                        {shouldIframeReload && (
                          <iframe
                            key={selectedSwagger.url ?? ""}
                            src={selectedSwagger.url ?? ""}
                            width="99%"
                            height="800"
                          />
                        )}

                        {apiError && (
                          <div
                            style={{
                              color: 'red',
                              marginTop: '10px',
                              textAlign: 'center',
                              fontWeight: 'bold'
                            }}
                          >
                            {apiError}
                          </div>
                        )}
                      </div>
                    )}
                    {activeTab === "permission" && (
                      <div className="form">
                        <div className="form-group" ref={dropdownRef} style={{ width: "55%" }}>
                          <label style={{ fontWeight: "bold" }}>
                            Permission : "{name}"
                          </label>
                          <div className="dropdown">
                            <div
                              className="dropdown-header"
                              onClick={() => setShowDropdown(!showDropdown)}
                              role="button"
                              tabIndex={0}
                              onKeyDown={(e) => {
                                if (e.key === "Enter" || e.key === " ") {
                                  setShowDropdown(!showDropdown);
                                }
                              }}
                            >
                              {selectedPermission.length > 0
                                ? selectedPermission
                                  .map((id) => permissions.find((p) => p.id === id)?.name)
                                  .join(", ")
                                : "Select Permission"}
                            </div>

                            {showDropdown && (
                              <div className="dropdown-list">
                                {permissions.map((perm) => (
                                  <label key={perm.id} className="checkbox-item">
                                    <input
                                      type="checkbox"
                                      checked={selectedPermission.includes(perm.id)}
                                      onChange={() => handleCheckboxChange(perm.id)}
                                    />
                                    {perm.name}
                                  </label>
                                ))}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                    {activeTab === "rules" && (
                      <div className="form">

                        {/* Title */}
                        <div
                          className="form-group"
                          ref={dropdownRef}
                          style={{ width: "55%" }}
                        >
                          <label style={{ fontWeight: "bold" }}>
                            Rules for Event : "{name}"
                          </label>
                        </div>
                        <div className="form-group">
                          <div className="rule-input-row" style={{ display: "flex", alignItems: "center", gap: "8px" }}                          >
                            <select
                              value={ruleConstraint}
                              onChange={(e) => {
                                setRuleConstraint(Number(e.target.value));
                                setRuleConstraintValue(""); // reset dependent dropdown
                                // 👇 call your function here
                                getCalloutNameFromConstraintdropdown(e);
                              }}
                              style={{ padding: "6px", width: "150px", marginRight: "6px" }}
                            >
                              <option value="">Select Constraint Field</option>
                              {ruleConstraintList?.map((event) => (
                                <option key={event.id} value={event.id}>
                                  {event.constraint}
                                </option>
                              ))}
                            </select>
                            <input
                              ref={inputRef}
                              type="text"
                              value={ruleCalloutName}
                              placeholder="Callout Name"
                              onChange={(e) => setRuleCalloutName(e.target.value)}
                              onKeyDown={(e) => e.key === "Enter" && addRule()}
                              style={{
                                whiteSpace: "nowrap",
                                flexShrink: 0,
                                marginTop: "-15px", 
                              }}
                              disabled={disabledCalloutName}
                            />
                            <IconButton
                              onClick={() => {
                                setDisabledCalloutName(false);
                                // wait for state update, then focus
                                setTimeout(() => {
                                  inputRef.current?.focus();
                                }, 0);
                              }
                              }
                              sx={{
                                backgroundColor: "#fff",
                                marginTop: "-15px",
                                width: "32px",      // better than 5px (5px is too small to click)
                                height: "10px",
                                "&:hover": {
                                  backgroundColor: "#f5f5f5" // light hover effect
                                }
                              }}
                            >
                              <EditIcon />
                            </IconButton>
                            <select
                              value={ruleConstraintValue}
                              onChange={(e) => {
                                setRuleConstraintValue(Number(e.target.value));
                              }}
                              style={{ padding: "6px", width: "150px" }}
                              disabled={!filteredValues.length}
                            >
                              <option value="">Possible Constraint Values</option>

                              {filteredValues.length > 0 ? (
                                filteredValues.map((event) => (
                                  <option key={event.id} value={event.id}>
                                    {event.constraintValue}
                                  </option>
                                ))
                              ) : (
                                <option disabled>No values available</option>
                              )}
                            </select>
                            <button
                              style={{
                                whiteSpace: "nowrap",
                                flexShrink: 0,
                                marginTop: "-15px",
                              }}
                              onClick={addRule}
                            >
                              Save
                            </button>
                          </div>
                        </div>

                        {/* Table */}
                        <div className="view-notes-table-wrapper"
                          style={{
                            maxHeight: "225px",
                            overflowY: "auto",
                            overflowX: "auto",
                            padding: "0 0px 0px",
                          }}
                        >
                          <table className="view-notes-table"

                          >
                            <thead>
                              <tr>
                                <th>S.No</th>
                                <th>Constraint Fields</th>
                                <th>Callout Name</th>
                                <th>Constraint Value</th>
                                {/*  <th>Edit</th> NEW */}
                                <th>Delete</th> {/* NEW */}
                              </tr>
                            </thead>

                            <tbody>
                              {rulesList.length > 0 ? (
                                rulesList.map((rule, index) => (
                                  <tr key={rule.id}>
                                    <td>{index + 1}</td>
                                    <td title={rule.constraint}>{rule.constraint}</td>
                                    <td title={rule.calloutName}>{rule.calloutName}</td>
                                    <td title={rule.name}>{rule.name}</td>
                                    {/* <td>
                                      <IconButton

                                        onClick={() => handleEdit(rule.id)}
                                        sx={{
                                          color: "error.main"
                                        }}
                                      >
                                        <EditIcon />
                                      </IconButton>

                                    </td> */}
                                    <td>
                                      <IconButton

                                        onClick={() => ConfirmtoDeleteRules('Delete', rule.id)}
                                        sx={{
                                          color: "error.main"
                                        }}
                                      >
                                        <DeleteIcon />
                                      </IconButton>

                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan="5" className="no-data">
                                    No Constraints Added
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </DragDropContext>
          </>
      }
      <EventConfirmPopup
        openConfirmationPopup={isPopupOpen}
        onClose={openPopupEvent}
        handleCancel={handleCancel}
        handleSave={handleSaveConfirm}
        isLoading={isLoading}
        popupData={confirmPopupData}
      />

      <CustomToaster />
    </>
  );
};

export default EventCreation;
